import React, { Component } from 'react';
import IconDashboardWarning from '../../assets/icons/IconDashboardWarning';

class DashboardWarningAlert extends Component {
    render() {
        return (
            <div className={this.props.show ? "flex items-center bg-white rounded shadow-lg p-2 w-max mb-5" : "hidden"}>
                <IconDashboardWarning />
                <p className="ml-2">Halaman ini belum diperbaharui, Silahkan perbaharui.</p>
            </div>
        );
    }
}

export default DashboardWarningAlert;